
// mport { check } from 'prettier';
import { DEFAULT_RADIUS } from '../../../util/constants';
export default {
  props: {
    tab: {
      type: String,
      default: 'region',
    },
    type: {
      type: String,
      default: 'pickup',
    },
    routeValidation: {
      type: Boolean,
      default: false,
    },
    isTruck: {
      type: Boolean,
      default: false,
    },
    filterProp: {
      type: Object,
      default: () => {},
    },
    filterPropState: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      selectedStates: [],
      selectedRegions: [],
      suburbs: [],
      DEFAULT_RADIUS,
      valueString: 'Any',
      filter: {
        suburb: '',
        regionPrefixes: [],
        radius: this.tab === 'region' ? DEFAULT_RADIUS : null,
      },
      prefixes: [],
      qld: ['QLD Central', 'QLD Brisbane Region', 'QLD North', 'QLD South'],
      nsw: ['NSW Sydney Region', 'NSW North', 'NSW South', 'NSW West'],
      vic: ['VIC East', 'VIC Melbourne', 'VIC North', 'VIC West'],
      wa: ['WA Central', 'WA East', 'WA Perth', 'WA North', 'WA South'],
      sa: [
        'SA Central',
        'SA Adelaide Region',
        'SA North',
        'SA South',
        'SA West',
      ],
      nt: ['NT Central', 'NT Darwin Region'],
      qld_selected: [],
      allQldSelected: false,
      qldIndeterminate: false,
      nsw_selected: [],
      allNswSelected: false,
      nswIndeterminate: false,
      vic_selected: [],
      allVicSelected: false,
      vicIndeterminate: false,
      wa_selected: [],
      allWaSelected: false,
      waIndeterminate: false,
      sa_selected: [],
      allSaSelected: false,
      saIndeterminate: false,
      nt_selected: [],
      allNtSelected: false,
      ntIndeterminate: false,
    };
  },
  watch: {
    qld_selected(newValue, oldValue) {
      this.qld_selected = newValue;
      if (newValue.length === 0) {
        this.qldIndeterminate = false;
        this.allQldSelected = false;
      } else if (newValue.length === this.qld.length) {
        this.qldIndeterminate = false;
        this.allQldSelected = true;
      } else {
        this.qldIndeterminate = true;
        this.allQldSelected = false;
      }
    },
    nsw_selected(newValue, oldValue) {
      this.nsw_selected = newValue;
      if (newValue.length === 0) {
        this.nswIndeterminate = false;
        this.allNswSelected = false;
      } else if (newValue.length === this.nsw.length) {
        this.nswIndeterminate = false;
        this.allNswSelected = true;
      } else {
        this.nswIndeterminate = true;
        this.allNswSelected = false;
      }
    },
    vic_selected(newValue, oldValue) {
      this.vic_selected = newValue;
      if (newValue.length === 0) {
        this.vicIndeterminate = false;
        this.allVicSelected = false;
      } else if (newValue.length === this.vic.length) {
        this.vicIndeterminate = false;
        this.allVicSelected = true;
      } else {
        this.vicIndeterminate = true;
        this.allVicSelected = false;
      }
    },
    wa_selected(newValue, oldValue) {
      this.wa_selected = newValue;
      if (newValue.length === 0) {
        this.waIndeterminate = false;
        this.allWaSelected = false;
      } else if (newValue.length === this.wa.length) {
        this.waIndeterminate = false;
        this.allWaSelected = true;
      } else {
        this.waIndeterminate = true;
        this.allWaSelected = false;
      }
    },
    sa_selected(newValue, oldValue) {
      this.sa_selected = newValue;
      if (newValue.length === 0) {
        this.saIndeterminate = false;
        this.allSaSelected = false;
      } else if (newValue.length === this.sa.length) {
        this.saIndeterminate = false;
        this.allSaSelected = true;
      } else {
        this.saIndeterminate = true;
        this.allSaSelected = false;
      }
    },
    nt_selected(newValue, oldValue) {
      this.nt_selected = newValue;
      if (newValue.length === 0) {
        this.ntIndeterminate = false;
        this.allntSelected = false;
      } else if (newValue.length === this.nt.length) {
        this.ntIdeterminate = false;
        this.allNtSelected = true;
      } else {
        this.ntIndeterminate = true;
        this.allNtSelected = false;
      }
    },
    // filter: {
    //   handler() {
    //     this.handleChange();
    //     this.getValueString();
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    filterProp: {
      handler() {
        if (this.tab !== 'state') {
          if (this.filterProp?.type || this.filterProp?.radius) {
            if (this.filterProp.type) {
              this.getSuburbs(
                this.filterProp.type.toString(),
                true,
                this.filterProp?.radius || DEFAULT_RADIUS
              );
            }
          } else {
            const tempFilter = {
              suburb: null,
              radius: DEFAULT_RADIUS,
            };
            this.filter = tempFilter;
          }
          this.getValueString();
        }
      },
      deep: true,
      immediate: true,
    },
    filterPropState: {
      handler() {
        if (this.tab === 'state') {
          if (this.filterPropState !== null) {
            this.selectedStates = this.filterPropState;
          } else {
            this.selectedStates = [];
          }
          this.$emit('value-changed', this.selectedStates);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setFilter(suburb) {
      this.filter = { ...this.filter, suburb };
    },
    customLabel({ suburb, postcode }) {
      return `${suburb} – ${postcode}`;
    },
    getValueString() {
      this.valueString =
        this.filter.suburb && this.filter.suburb.suburb
          ? this.filter.suburb.suburb +
            (this.tab !== 'route'
              ? ', ' +
                (this.filter.radius
                  ? this.filter.radius + 'km'
                  : DEFAULT_RADIUS + ' km')
              : '')
          : 'Any';
    },
    handleChange() {
      if (this.tab === 'state') {
        this.$emit('value-changed', this.selectedStates);
      } else {
        this.filter.regionPrefixes = [...this.qld_selected, ...this.nsw_selected, ...this.wa_selected, ...this.sa_selected, ...this.vic_selected, ...this.nt_selected]
        this.$emit('value-changed', this.filter);
      }
    },
    getSuburbs(searchString, defaultSearch = false, radius = DEFAULT_RADIUS) {
      const payload = {
        searchString,
      };
      if (searchString && searchString.length > 1) {
        this.loading = true;
        this.$store.dispatch('lookup/getSuburbs', payload).then((res) => {
          if (res) {
            if (defaultSearch) {
              if (res.length > 0) {
                const result = res.filter(
                  (x) =>
                    x.suburb.toLowerCase() === searchString.toLowerCase() ||
                    x.suburb.toLowerCase() ===
                      searchString.toLowerCase() + ' city'
                );
                if (result.length > 0) {
                  this.filter = {};
                  this.filter.suburb = result[0];
                  this.filter.radius = radius;
                }
              }
              this.$emit('value-changed', this.filter);
            }
            this.suburbs = res;
          }
          this.loading = false;
        });
      }
    },
    toggleAllQld(checked) {
      if (checked) {
        this.qld_selected = this.qld.slice();
        this.prefixes?.push(...this.qld_selected);
      } else {
        this.qld_selected = [];
        this.prefixes = this.prefixes.filter(
          (element) => !this.qld.includes(element)
        );
      }
      this.handleChange()
    },
    toggleAllNsw(checked) {
      if (checked) {
        this.nsw_selected = this.nsw.slice();
        this.prefixes?.push(...this.nsw_selected);
      } else {
        this.nsw_selected = [];
        this.prefixes = this.prefixes.filter(
          (element) => !this.nsw.includes(element)
        );
      }
      this.handleChange()
    },
    toggleAllVic(checked) {
      if (checked) {
        this.vic_selected = this.vic.slice();
        this.prefixes?.push(...this.vic_selected);
      } else {
        this.vic_selected = [];
        this.prefixes = this.prefixes.filter(
          (element) => !this.vic.includes(element)
        );
      }
      this.handleChange()
    },
    toggleAllSa(checked) {
      if (checked) {
        this.sa_selected = this.sa.slice();
        this.prefixes?.push(...this.sa_selected);
      } else {
        this.sa_selected = [];
        this.prefixes = this.prefixes.filter(
          (element) => !this.sa.includes(element)
        );
      }
      this.handleChange()
    },
    toggleAllWa(checked) {
      if (checked) {
        this.wa_selected = this.wa.slice();
        this.prefixes?.push(...this.wa_selected);
      } else {
        this.wa_selected = [];
        this.prefixes = this.prefixes.filter(
          (element) => !this.wa.includes(element)
        );
      }
      this.handleChange()
    },
    toggleAllNt(checked) {
      if (checked) {
        this.nt_selected = this.nt.slice();
        this.prefixes?.push(...this.nt_selected);
      } else {
        this.nt_selected = [];
        this.prefixes = this.prefixes.filter(
          (element) => !this.nt.includes(element)
        );
      }
      this.handleChange()
    },
  },
};
